var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.lesson.sections),function(section,index){return _c('Section',{key:index,attrs:{"section":section}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }